import { motion } from "framer-motion";
import { Milk, Egg, Apple, Carrot, IceCreamCone, CupSoda, Citrus } from "lucide-react";

const float = (dur, delay = 0, drift = 10) => ({
  animate: { y: [0, -drift, 0], rotate: [0, drift > 8 ? 4 : -3, 0] },
  transition: { duration: dur, delay, repeat: Infinity, ease: "easeInOut" },
});

const ITEMS = [
  { id: "milk", Icon: Milk, style: { top: "16%", left: "8%" }, size: 34, dur: 5.5, d: 0.2 },
  { id: "egg", Icon: Egg, style: { top: "30%", right: "9%" }, size: 26, dur: 6.2, d: 0.8 },
  { id: "apple", Icon: Apple, style: { top: "54%", left: "10%" }, size: 30, dur: 5.8, d: 0.4 },
  { id: "carrot", Icon: Carrot, style: { top: "68%", right: "12%" }, size: 30, dur: 6.6, d: 1.1 },
  { id: "icecream", Icon: IceCreamCone, style: { top: "80%", left: "14%" }, size: 26, dur: 5.2, d: 0.6 },
  { id: "soda", Icon: CupSoda, style: { top: "44%", right: "7%" }, size: 26, dur: 6.9, d: 0.3 },
  { id: "citrus", Icon: Citrus, style: { top: "88%", right: "18%" }, size: 24, dur: 5.9, d: 0.9 },
];

const MAGNETS = [
  { text: "who ate it?", style: { top: "34%", right: "5%", rotate: "6deg" }, dur: 4.8 },
  { text: "leftovers?", style: { top: "52%", left: "5%", rotate: "-5deg" }, dur: 5.4 },
];

export default function HomeScene() {
  return (
    <div className="absolute inset-x-0 top-0 h-[560px] overflow-hidden pointer-events-none select-none" aria-hidden="true">
      {/* Fridge door-light flicker */}
      <motion.div
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-[120%] h-64 rounded-full"
        style={{ background: "radial-gradient(closest-side, rgba(255,248,224,0.9), rgba(255,248,224,0))" }}
        animate={{ opacity: [0.55, 0.9, 0.5, 0.85, 0.6] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
      />

      {ITEMS.map(({ id, Icon, style, size, dur, d }, i) => (
        <motion.div key={id} className="absolute text-[#16242a]/[0.16]" style={style} {...float(dur, d, i % 2 ? 12 : 8)}>
          <Icon width={size} height={size} strokeWidth={1.4} />
        </motion.div>
      ))}

      {MAGNETS.map((m) => (
        <motion.div
          key={m.text}
          className="absolute glass rounded-full px-3 py-1.5 text-[11px] font-mono lowercase tracking-wide text-[#4a5c62]"
          style={{ ...m.style, transform: `rotate(${m.style.rotate})` }}
          animate={{ y: [0, -6, 0], rotate: [m.style.rotate, `calc(${m.style.rotate} + 2deg)`, m.style.rotate] }}
          transition={{ duration: m.dur, repeat: Infinity, ease: "easeInOut" }}
        >
          {m.text}
        </motion.div>
      ))}
    </div>
  );
}
